"use strict";

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BatibouwFinderCell;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function BatibouwFinderCell(_ref4) {
  var cell = _ref4.cell,
    _ref4$uriTransformer = _ref4.uriTransformer,
    uriTransformer = _ref4$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref4$uriTransformer,
    intl = _ref4.intl,
    defaultLanguage = _ref4.defaultLanguage,
    project = _ref4.project,
    logEvent = _ref4.logEvent;
  var _ref5 = (0, _react.useState)({}),
    _ref6 = _slicedToArray(_ref5, 2),
    userDatas = _ref6[0],
    setuserDatas = _ref6[1];
  var questions = [{
    title: "Quel type de logement possédez-vous ?",
    category: "Informations générales",
    multiple: false,
    responses: [{
      title: "Maison individuelle"
    }, {
      title: "Appartement"
    }, {
      title: "Immeuble divisé"
    }, {
      title: "Autre"
    }]
  }, {
    title: "Quelle est l'année de construction de votre logement ?",
    category: "Informations générales",
    multiple: false,
    responses: [{
      title: "Avant 1945"
    }, {
      title: "1945-1975"
    }, {
      title: "1975-2000"
    }, {
      title: "2000-2015"
    }, {
      title: "Après 2015"
    }]
  }, {
    title: "Quelle est la surface habitable approximative de votre logement ?",
    category: "Informations générales",
    multiple: false,
    responses: false
  }, {
    title: "Combien de niveaux comporte votre logement ?",
    category: "Informations générales",
    multiple: false,
    responses: [{
      title: "Plain-pied",
      val: 1
    }, {
      title: "2 étages",
      val: 2
    }, {
      title: "3 étages",
      val: 3
    }, {
      title: "4 étages",
      val: 4
    }, {
      title: "Plus de 4 étages",
      val: 5
    }]
  }, {
    title: "La maison est elle mitoyenne ?",
    category: "Informations générales",
    multiple: false,
    responses: [{
      title: "Maison mitoyenne d'un côté"
    }, {
      title: "Maison mitoyenne de deux côtés"
    }, {
      title: "Maison non mitoyenne"
    }]
  }, {
    title: "Quel est votre mode de chauffage principal ?",
    category: "Système de chauffage",
    multiple: false,
    responses: [{
      title: "Chaudière gaz",
      geste: true,
      senario: [{
        number: 2,
        solution: "Pompe à chaleur AIR EAU"
      }, {
        number: 0,
        solution: "Radiateurs électriques connectés avec batterie de stockage intégrée"
      }],
      economie: [0.2, 0],
      economie_pv: [0.25, 0.15],
      price_functions: [function () {
        return 15000;
      }, function (shab) {
        return 120 * shab;
      }]
    }, {
      title: "Chaudière fioul",
      geste: true,
      senario: [{
        number: 1,
        solution: "Pompe a chaleur AIR EAU"
      }, {
        number: 2,
        solution: "Radiateurs électriques connectés avec batterie de stockage intégrée"
      }],
      economie: [0.35, 40],
      economie_pv: [0.4, 0.45],
      price_functions: [function () {
        return 15000;
      }, function (shab) {
        return 120 * shab;
      }]
    }, {
      title: "Pompe à chaleur AIR EAU",
      economie: [0.05],
      price_functions: [function () {
        return 15000;
      }]
    }, {
      title: "Pompe à chaleur AIR AIR",
      economie: [-0.05],
      economie_pv: [0.10],
      price_functions: [function (shab) {
        return shab * 120;
      }]
    }, {
      title: "Poêle à bois/pellets",
      economie: [0],
      price_functions: [function (shab) {
        return 120 * shab;
      }]
    }, {
      title: "Insert/Cheminée à bois",
      economie: [0],
      price_functions: [function (shab) {
        console.log({
          shab: shab
        });
        return shab * 120;
      }]
    }, {
      title: "Chaudière bois/granulés",
      economie: [0.05],
      economie_pv: [0.10],
      price_functions: [function () {
        return 15000;
      }]
    }, {
      title: "Chaudière électrique",
      economie: [-0.05],
      economie_pv: [0.10],
      price_functions: [function (shab) {
        return shab * 120;
      }]
    }, {
      title: "Radiateurs électrique",
      geste: true,
      senario: [{
        number: 2,
        solution: "Radiateurs électriques connectés avec batterie de stockage intégrée"
      }],
      economie: [0.45],
      economie_pv: [0.60],
      price_functions: [function (shab) {
        return shab * 120;
      }]
    }, {
      title: "Plancher chauffant électrique",
      senario: [{
        number: 2,
        solution: "Radiateurs électriques connectés avec batterie de stockage intégrée"
      }],
      geste: true,
      economie: [0.45],
      economie_pv: [0.60],
      price_functions: [function (shab) {
        return shab * 120;
      }]
    }, {
      title: "Autre",
      geste: false,
      price_functions: [function () {
        return 0;
      }]
    }]
  }, {
    title: "Quel est l’âge de votre installation de chauffage ?",
    category: "Système de chauffage",
    multiple: false,
    responses: [{
      title: "Moins de 5 ans"
    }, {
      title: "5-10 ans"
    }, {
      title: "Plus de 10 ans"
    }, {
      title: "Je ne sais pas"
    }]
  }, {
    title: "Avez-vous un thermostat connecté ou programmable ?",
    category: "Système de chauffage",
    multiple: false,
    responses: [{
      title: "Oui"
    }, {
      title: "Non",
      senario: [{
        number: 1,
        solution: "Vannes thermostatiques connectées"
      }, {
        number: 2,
        solution: "Vannes thermostatiques connectées"
      }]
    }, {
      title: "Je ne sais pas"
    }]
  }, {
    title: "Quels sont vos autres mode de chauffage ? (Plusieurs réponses possibles)",
    category: "Système de chauffage",
    multiple: true,
    responses: [{
      title: "Aucun"
    }, {
      title: "Chaudière gaz",
      geste: true
    }, {
      title: "Chaudière fioul",
      geste: true
    }, {
      title: "Pompe à chaleur AIR EAU"
    }, {
      title: "Pompe à chaleur AIR AIR"
    }, {
      title: "Poêle à bois/pellets"
    }, {
      title: "Insert/Cheminée à bois"
    }, {
      title: "Chaudière bois/granulés"
    }, {
      title: "Chaudière électrique"
    }, {
      title: "Radiateurs électrique",
      geste: true
    }, {
      title: "Plancher chauffant électrique",
      geste: true
    }, {
      title: "Autre"
    }]
  }, {
    title: "Quel est votre système d'eau chaude sanitaire ?",
    category: "Système d'eau chaude sanitaire",
    multiple: false,
    responses: [{
      title: "Chaudière",
      senario: [{
        number: 1,
        solution: "Boiler thermodynamique"
      }, {
        number: 2,
        solution: "Boiler thermodynamique"
      }],
      economie: [0.15],
      price_functions: [function () {
        return 3900;
      }]
    }, {
      title: "Boiler électrique",
      senario: [{
        number: 2,
        solution: "Boiler thermodynamique"
      }],
      economie: [0.20],
      price_functions: [function () {
        return 3900;
      }]
    }, {
      title: "Boiler thermodynamique",
      economie: [0.03]
    }, {
      title: "Boiler solaire",
      economie: [0.04]
    }, {
      title: "Boiler gaz",
      senario: [{
        number: 2,
        solution: "Boiler thermodynamique"
      }],
      economie: [0.15],
      price_functions: [function () {
        return 3900;
      }]
    }, {
      title: "Chauffe eau instantané",
      senario: [{
        number: 1,
        solution: "Boiler électrique"
      }, {
        number: 2,
        solution: "Boiler thermodynamique"
      }],
      economie: [0.25],
      price_functions: [function () {
        return 3900;
      }]
    }]
  }, {
    title: "Combles perdus (Plusieurs réponses possibles)",
    category: "Type de toiture",
    multiple: true,
    responses: [{
      title: "Combles aménagés"
    }, {
      title: "Toiture terrasse"
    }]
  }, {
    title: "Votre toiture est-elle isolée ?",
    category: "Isolation",
    multiple: false,
    responses: [{
      title: "Isolation récente",
      geste: false,
      economie: [0.08],
      price_functions: {
        combles_perdus: function combles_perdus(shab, nb_niv) {
          return shab * nb_niv * 70;
        },
        comble_amenages: function comble_amenages(shab, nb_niv) {
          return shab * nb_niv * 70 * 1.2;
        }
      }
    }, {
      title: "Isolation ancienne",
      geste: true,
      senario: [{
        number: 1,
        solution: "Isolation Toiture"
      }, {
        number: 2,
        solution: "Isolation Toiture"
      }],
      economie: [0.18],
      price_functions: {
        combles_perdus: function combles_perdus(shab, nb_niv) {
          return shab * nb_niv * 70;
        },
        comble_amenages: function comble_amenages(shab, nb_niv) {
          return shab * nb_niv * 70 * 1.2;
        }
      }
    }, {
      title: "Non",
      geste: true,
      senario: [{
        number: 1,
        solution: "Isolation Toiture"
      }, {
        number: 2,
        solution: "Isolation Toiture"
      }],
      economie: [0.28],
      price_functions: {
        combles_perdus: function combles_perdus(shab, nb_niv) {
          return shab * nb_niv * 70;
        },
        comble_amenages: function comble_amenages(shab, nb_niv) {
          return shab * nb_niv * 70 * 1.2;
        }
      }
    }, {
      title: "Je ne sais pas",
      geste: false,
      economie: [0],
      price_functions: {
        combles_perdus: function combles_perdus(shab, nb_niv) {
          return shab * nb_niv * 70;
        },
        comble_amenages: function comble_amenages(shab, nb_niv) {
          return shab * nb_niv * 70 * 1.2;
        }
      }
    }],
    functions: {
      combles_perdus: function combles_perdus(shab, nb_niv) {
        return shab * nb_niv * 70;
      },
      comble_amenages: function comble_amenages(shab, nb_niv) {
        return shab * nb_niv * 70 * 1.2;
      }
    }
  }, {
    title: "Vos murs sont-ils isolés par l'extérieur ?",
    category: "Isolation",
    multiple: false,
    responses: [{
      title: "Isolation récente",
      economie: [0.05],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Isolation ancienne",
      economie: [0.13],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Non",
      geste: true,
      senario: [{
        number: 2,
        solution: "Isolation des murs par l'intérieur ou l'extérieur"
      }],
      economie: [0.23],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Je ne sais pas",
      economie: [0],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }],
    price_functions: {
      maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
        return shab * 120;
      },
      maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
        return shab * 120 * 0.75;
      },
      maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
        return shab * 120 * 0.5;
      }
    }
  }, {
    title: "Vos murs sont-ils isolés par l'intérieur ?",
    category: "Isolation",
    multiple: false,
    responses: [{
      title: "Isolation récente",
      economie: [0.05],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Isolation ancienne",
      economie: [0.13],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Non",
      geste: true,
      senario: [{
        number: 2,
        solution: "Isolation des murs par l'intérieur ou l'extérieur"
      }],
      economie: [0.23],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }, {
      title: "Je ne sais pas",
      economie: [0],
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      }
    }],
    price_functions: {
      maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
        return shab * 120;
      },
      maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
        return shab * 120 * 0.75;
      },
      maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
        return shab * 120 * 0.5;
      }
    }
  }, {
    title: "Votre sol ou plafond de cave est-il isolé ?",
    category: "Isolation",
    multiple: false,
    responses: [{
      title: "Isolation récente",
      economie: [0.02],
      price_functions: {
        calcule: function calcule(nb_niv, shab) {
          return nb_niv * shab * 70;
        }
      }
    }, {
      title: "Isolation ancienne",
      geste: true,
      senario: [{
        number: 2,
        solution: "Isolation du plafond du sous sol"
      }],
      economie: [0.06],
      price_functions: {
        calcule: function calcule(nb_niv, shab) {
          return nb_niv * shab * 70;
        }
      }
    }, {
      title: "Non",
      geste: true,
      senario: [{
        number: 1,
        solution: "Isolation du plafond du sous sol"
      }, {
        number: 2,
        solution: "Isolation du plafond du sous sol"
      }],
      economie: [0.12],
      price_functions: {
        calcule: function calcule(nb_niv, shab) {
          return nb_niv * shab * 70;
        }
      }
    }, {
      title: "Je ne sais pas",
      geste: false,
      economie: [0],
      price_functions: {
        calcule: function calcule(nb_niv, shab) {
          return nb_niv * shab * 70;
        }
      }
    }],
    price_functions: {
      calcule: function calcule(nb_niv, shab) {
        return nb_niv * shab * 70;
      }
    }
  }, {
    title: "Quel type de vitrage avez-vous ?",
    category: "Ouvertures et ventilation",
    multiple: false,
    responses: [{
      title: "Simple vitrage",
      senario: [{
        number: 2,
        solution: "Remplacement des menuiseries"
      }],
      economie: [0.08],
      price_functions: {
        calcule: function calcule(shab) {
          return shab * 130;
        }
      }
    }, {
      title: "Double vitrage ",
      economie: [0.04],
      price_functions: {
        calcule: function calcule(shab) {
          return shab * 130;
        }
      }
    }, {
      title: "Triple vitrage",
      economie: [0.02],
      price_functions: {
        calcule: function calcule(shab) {
          return shab * 130;
        }
      }
    }],
    price_functions: {
      calcule: function calcule(shab) {
        return shab * 130;
      }
    }
  }, {
    title: "Avez-vous un système de ventilation ?",
    category: "Ouvertures et ventilation",
    multiple: false,
    responses: [{
      title: "VMC simple flux",
      senario: [{
        number: 2,
        solution: "VMC simple flux hygroréglable"
      }],
      economie: [0.04],
      price_functions: function price_functions() {
        return 1500;
      }
    }, {
      title: "VMC double flux",
      economie: [0.01],
      price_functions: function price_functions() {
        return 6000;
      }
    }, {
      title: "Aération naturelle",
      economie: [0.03],
      price_functions: function price_functions() {
        return 3000;
      }
    }, {
      title: "Aucun",
      economie: [0.03],
      price_functions: function price_functions() {
        return 3000;
      }
    }, {
      title: "Je ne sais pas",
      economie: [0]
    }],
    price_functions: {
      aucun: function aucun() {
        return 3000;
      },
      simple: function simple() {
        return 1500;
      },
      double: function double() {
        return 6000;
      },
      naturelle: function naturelle() {
        return 3000;
      }
    }
  }, {
    title: "Quelle est votre consommation annuelle d'énergie ? (En euros)",
    category: "Consommation et production d’énergie",
    multiple: false,
    responses: false
  }, {
    title: "Quel est votre fournisseur d’énergie ?",
    category: "Consommation et production d’énergie",
    multiple: false,
    responses: [{
      title: "Engie"
    }, {
      title: "Luminus"
    }, {
      title: "TotalEnergies"
    }, {
      title: "Autre"
    }]
  }, {
    title: "Avez-vous une installation photovoltaïque ?",
    category: "Consommation et production d’énergie",
    multiple: false,
    responses: [{
      title: "Non",
      senario: [{
        number: 2,
        solution: "PV 4,5 kWc"
      }]
    }, {
      title: "Jusqu'à 3 kWc"
    }, {
      title: "Entre 3 kWc et 6 kWc"
    }, {
      title: "Entre 6 kWc et 9 kWc"
    }, {
      title: "Plus de 9 kWc"
    }]
  }, {
    title: "Avez-vous une batterie photovoltaïque ?",
    category: "Consommation et production d’énergie",
    multiple: false,
    responses: [{
      title: "Oui"
    }, {
      title: "Non mais j’envisage d’en installer une"
    }, {
      title: "Non"
    }]
  }, {
    title: "Avez-vous une borne de recharge pour véhicule électrique ?",
    category: "Consommation et production d’énergie",
    multiple: false,
    responses: [{
      title: "Oui"
    }, {
      title: "Non mais j’envisage d’en installer une"
    }, {
      title: "Non"
    }]
  }, {
    title: "Quels travaux d’amélioration énergétique envisagez-vous ? (Plusieurs réponses possibles)",
    category: "Budget et projets",
    multiple: true,
    responses: [{
      title: "Isolation de la toiture",
      geste: true,
      price_functions: {
        combles_perdus: function combles_perdus(shab, nb_niv) {
          return shab * nb_niv * 70;
        },
        combles_amenages: function combles_amenages(shab, nb_niv) {
          return shab * nb_niv * 70 * 1.2;
        }
      },
      economie: [0.08, 0.18, 0.28]
    }, {
      title: "Isolation des murs",
      geste: true,
      price_functions: {
        maison_non_mitoyenne: function maison_non_mitoyenne(shab) {
          return shab * 120;
        },
        maison_mitoyenne_un_cote: function maison_mitoyenne_un_cote(shab) {
          return shab * 120 * 0.75;
        },
        maison_mitoyenne_deux_cotes: function maison_mitoyenne_deux_cotes(shab) {
          return shab * 120 * 0.5;
        }
      },
      economie: [0.05, 0.13, 0.23]
    }, {
      title: "Isolation des sols",
      geste: true,
      price_functions: {
        calcule: function calcule(nb_niv, shab) {
          return nb_niv * shab * 70;
        }
      },
      economie: [0.02, 0.06, 0.12]
    }, {
      title: "Remplacement des fenêtres",
      price_functions: {
        calcule: function calcule(shab) {
          return shab * 130;
        }
      },
      economie: [0.08, 0.04, 0.02]
    }, {
      title: "Changement de chauffage pour des radiateurs électriques connectés avec batterie de stockage intégrée",
      geste: true,
      price_functions: [function (shab) {
        return shab * 120;
      }],
      economie: [0.45]
    }, {
      title: "Changement de chauffage pour une pompe à chaleur ",
      geste: true,
      price_functions: function price_functions(shab) {
        return 120 * shab;
      },
      economie: [0.05]
    }, {
      title: "Changement de système d'eau chaude sanitaire pour un boiler électrique",
      price_functions: function price_functions() {
        return 3900;
      },
      economie: [0.20]
    }, {
      title: "Changement de système d'eau chaude sanitaire pour un boiler thermodynamique",
      price_functions: function price_functions() {
        return 3900;
      },
      economie: [0.03]
    }, {
      title: "Installation de panneaux solaires",
      pv: true,
      price_functions: [function () {
        return 6500;
      }],
      economie: [0]
    }, {
      title: "Installation d'une VMC simple flux",
      price_functions: [function () {
        return 1500;
      }],
      economie: [0.04]
    }, {
      title: "Aucun",
      price_functions: [function () {
        return 0;
      }],
      economie: [0]
    }]
  }, {
    title: "Avez-vous déjà réalisé un audit ?",
    category: "Budget et projets",
    multiple: false,
    responses: [{
      title: "Oui"
    }, {
      title: "Non"
    }, {
      title: "Je ne sais pas"
    }]
  }, {
    title: "Quel budget envisagez-vous pour vos travaux ?",
    category: "Budget et projets",
    multiple: false,
    responses: [{
      title: "Moins de 5 000 €"
    }, {
      title: "5 000-10 000 €"
    }, {
      title: "10 000-20 000 €"
    }, {
      title: "Plus de 20 000 €"
    }, {
      title: "Je ne sais pas encore"
    }]
  }, {
    title: "Dans quelle région habitez vous ?",
    category: "Budget et projets",
    multiple: false,
    responses: [{
      title: "Flandre"
    }, {
      title: "Bruxelles"
    }, {
      title: "Wallonie"
    }]
  }];
  var categories = getUniqueCategories(questions);
  var _ref7 = (0, _react.useState)(1),
    _ref8 = _slicedToArray(_ref7, 2),
    opcacity = _ref8[0],
    setOpcacity = _ref8[1];
  var _ref9 = (0, _react.useState)([]),
    _ref0 = _slicedToArray(_ref9, 2),
    selectedResponses = _ref0[0],
    setSelectedResponses = _ref0[1];
  var _ref1 = (0, _react.useState)(-1),
    _ref10 = _slicedToArray(_ref1, 2),
    currentIndex = _ref10[0],
    setCurrentIndex = _ref10[1];
  var _ref11 = (0, _react.useState)(questions[0]),
    _ref12 = _slicedToArray(_ref11, 2),
    currentQuestion = _ref12[0],
    setCurrentQuestion = _ref12[1];
  var _ref13 = (0, _react.useState)(""),
    _ref14 = _slicedToArray(_ref13, 2),
    msg = _ref14[0],
    setMsg = _ref14[1];
  var addUserDatas = function addUserDatas(userData) {
    setuserDatas(_objectSpread(_objectSpread({}, userDatas), userData));
  };
  var nextQuestion = function nextQuestion() {
    if (!userDatas[currentQuestion.title] && currentIndex !== -1) {
      setMsg('Veuillez répondre à la question');
      return;
    }
    if (currentIndex < questions.length - 1) {
      setOpcacity(0);
      setSelectedResponses([]);
      setTimeout(function () {
        setCurrentIndex(currentIndex + 1);
        setCurrentQuestion(questions[currentIndex + 1]); // 🔥 Ici, on évite indexOf()
        setOpcacity(1);
        setMsg("");
      }, 200);
    }
  };
  (0, _react.useEffect)(function () {
    console.log({
      currentQuestion: currentQuestion
    }, {
      userDatas: userDatas
    });
  }, [currentQuestion, userDatas]);
  (0, _react.useEffect)(function () {
    console.log({
      currentIndex: currentIndex
    });
  }, [currentIndex]);
  if (currentIndex >= questions.length - 1) {
    return /*#__PURE__*/_react.default.createElement(ResultSenario, {
      questions: questions,
      userDatas: userDatas
    });
  }
  if (currentIndex === -1) {
    return /*#__PURE__*/_react.default.createElement(Formulaire, {
      nextQuestion: nextQuestion,
      setCurrentIndex: setCurrentIndex,
      currentIndex: currentIndex,
      msg: msg,
      setMsg: setMsg,
      userDatas: userDatas,
      setuserDatas: setuserDatas,
      opacity: opcacity,
      project: project
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontFamily: project ? project.default_button_font : 'arial',
      opacity: opcacity,
      backgroundColor: "rgba(0,0,0,0)",
      width: '100%',
      height: '100%',
      transitionDuration: '200ms',
      transitionTimingFunction: 'ease-in-out'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n                            .btn-suivant {\n                            margin-right: 4em;\n                            background: linear-gradient(94deg, #2630E9 0%, #222642 107.78%) !important;\n                            padding: 1em;\n                            border-radius: 2.4em;\n                            cursor: pointer;\n                            border: gray solid 1px;\n                        }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: '4em',
      color: '#67737C',
      fontSize: '0.6em'
    }
  }, currentQuestion.category), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: '1em',
      color: 'black',
      fontSize: '1.2em'
    }
  }, currentQuestion.title), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '14vh',
      top: '10vh',
      overflow: 'scroll',
      maxHeight: '52vh'
    }
  }, currentQuestion.responses ? /*#__PURE__*/_react.default.createElement(Responses, {
    selectedResponses: selectedResponses,
    setSelectedResponses: setSelectedResponses,
    userDatas: userDatas,
    addUserDatas: addUserDatas,
    currentQuestion: currentQuestion
  }) : /*#__PURE__*/_react.default.createElement(OpenField, {
    userDatas: userDatas,
    addUserDatas: addUserDatas,
    currentQuestion: currentQuestion
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '2em',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
      alignItems: 'end',
      marginTop: '2em'
    }
  }, currentIndex > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-suivant",
    style: {
      color: 'white',
      marginLeft: '4em',
      padding: '1em',
      borderRadius: '2.4em',
      cursor: 'pointer',
      border: 'gray solid 1px'
    },
    onClick: function onClick() {
      setOpcacity(0);
      setTimeout(function () {
        setCurrentIndex(currentIndex - 1);
        setCurrentQuestion(questions[currentIndex - 1]);
        setOpcacity(1);
      }, 200);
    }
  }, "Pr\xE9c\xE9dent"), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'red',
      fontSize: '0.8em',
      marginRight: '6em',
      width: '100%',
      textAlign: 'center'
    }
  }, msg), /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-suivant",
    style: {
      color: 'white',
      marginRight: '4em',
      padding: '1em',
      borderRadius: '2.4em',
      cursor: 'pointer',
      border: 'gray solid 1px'
    },
    onClick: nextQuestion
  }, "Suivant"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      bottom: '3em',
      width: '80%',
      left: '10%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '0.4em',
      backgroundColor: 'rgba(239, 85, 85, 0.35)'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "".concat((getCategoryIndex(categories, currentQuestion.category) + 1) * 100 / categories.length, "%"),
      height: '100%',
      backgroundColor: '#EF5555'
    }
  }))));
}
function ResultSenario(_ref15) {
  var userDatas = _ref15.userDatas,
    questions = _ref15.questions;
  var _ref16 = (0, _react.useState)(0),
    _ref17 = _slicedToArray(_ref16, 2),
    gestes = _ref17[0],
    setGestes = _ref17[1];
  var pv = userDatas["Avez-vous une batterie photovoltaïque ?"].title === "Oui";
  var plus10ans = userDatas["Quel est l’âge de votre installation de chauffage ?"].title === "Plus de 10 ans";
  var shab = parseInt(userDatas["Quelle est la surface habitable approximative de votre logement ?"]);
  var consomationA = parseInt(userDatas["Quelle est votre consommation annuelle d'énergie ? (En euros)"]);
  var combles_amenages = userDatas["Combles perdus (Plusieurs réponses possibles)"].title === "Combles aménagés";
  var _ref18 = (0, _react.useState)(0),
    _ref19 = _slicedToArray(_ref18, 2),
    economieEnergie1 = _ref19[0],
    setEconomieEnergie1 = _ref19[1];
  var _ref20 = (0, _react.useState)(0),
    _ref21 = _slicedToArray(_ref20, 2),
    economieEnergie2 = _ref21[0],
    setEconomieEnergie2 = _ref21[1];
  var _ref22 = (0, _react.useState)(0),
    _ref23 = _slicedToArray(_ref22, 2),
    economieEnergie3 = _ref23[0],
    setEconomieEnergie3 = _ref23[1];
  var _ref24 = (0, _react.useState)(0),
    _ref25 = _slicedToArray(_ref24, 2),
    economieAnnuelle1 = _ref25[0],
    setEconomieAnnuel1 = _ref25[1];
  var _ref26 = (0, _react.useState)(0),
    _ref27 = _slicedToArray(_ref26, 2),
    economieAnnuelle2 = _ref27[0],
    setEconomieAnnuel2 = _ref27[1];
  var _ref28 = (0, _react.useState)(0),
    _ref29 = _slicedToArray(_ref28, 2),
    economieAnnuelle3 = _ref29[0],
    setEconomieAnnuel3 = _ref29[1];
  var _ref30 = (0, _react.useState)(0),
    _ref31 = _slicedToArray(_ref30, 2),
    investissement1 = _ref31[0],
    setInvestissement1 = _ref31[1];
  var _ref32 = (0, _react.useState)(0),
    _ref33 = _slicedToArray(_ref32, 2),
    investissement2 = _ref33[0],
    setInvestissement2 = _ref33[1];
  var _ref34 = (0, _react.useState)(0),
    _ref35 = _slicedToArray(_ref34, 2),
    investissement3 = _ref35[0],
    setInvestissement3 = _ref35[1];
  var maison_mitoyenne = userDatas["La maison est elle mitoyenne ?"];
  var nb_niv = userDatas["Combien de niveaux comporte votre logement ?"].val;
  (0, _react.useEffect)(function () {
    _axios.default.post('https://api-gain.web-treeosk.online/play', {
      input: {
        game_id: 'f61dab73-9a56-4b50-943f-f3ab32b42f00',
        lang: 'fr',
        player_data: userDatas
      }
    }, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }, []);
  var _ref36 = (0, _react.useState)({
      "Toiture": [],
      //
      "Fenêtres": [],
      //
      "Système d'eau chaude sanitaire": [],
      //
      "Murs": [],
      //
      "Chauffage": [],
      //
      "Maitrise de l’énergie": [],
      "Planchers bas": [],
      //
      "VMC": [],
      //
      "Photovoltaique": [] //
    }),
    _ref37 = _slicedToArray(_ref36, 2),
    scenario1 = _ref37[0],
    setScenario1 = _ref37[1];
  var _ref38 = (0, _react.useState)(_objectSpread({}, scenario1)),
    _ref39 = _slicedToArray(_ref38, 2),
    scenario2 = _ref39[0],
    setScenario2 = _ref39[1];
  var _ref40 = (0, _react.useState)(_objectSpread({}, scenario1)),
    _ref41 = _slicedToArray(_ref40, 2),
    scenario3 = _ref41[0],
    setScenario3 = _ref41[1];
  (0, _react.useEffect)(function () {
    console.log(nb_niv);
    console.log(shab);
    var price1 = 0;
    var price2 = 0;
    var price3 = 0;
    var economie1 = 0;
    var economie2 = 0;
    var economie3 = 0;
    var iso_murs = false;
    var g_1 = 0;
    var g_2 = 0;
    var g_3 = 0;
    var senario3_target = {};
    var tempScenario1 = {
      "Toiture": [],
      "Fenêtres": [],
      "Système d'eau chaude sanitaire": [],
      "Murs": [],
      "Chauffage": [],
      "Maitrise de l’énergie": [],
      "Planchers bas": [],
      "VMC": [],
      "Photovoltaique": []
    };
    var tempScenario2 = _objectSpread({}, tempScenario1);
    Object.entries(userDatas).forEach(function (_ref42) {
      var _ref43 = _slicedToArray(_ref42, 2),
        key = _ref43[0],
        value = _ref43[1];
      if (value.senario) {
        var _iterator = _createForOfIteratorHelper(value.senario),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var senario = _step.value;
            var targetScenario = senario.number === 1 ? tempScenario1 : tempScenario2;
            var targetEconomie = senario.number === 1 ? economie1 : economie2;
            if (value.geste && senario.number === 1) {
              ++g_1;
            }
            if (value.geste && senario.number === 2) {
              ++g_2;
            }
            switch (key) {
              case 'Quels travaux d’amélioration énergétique envisagez-vous ? (Plusieurs réponses possibles)':
                value.forEach(function (reponse) {
                  switch (reponse.title) {
                    case 'Isolation de la toiture':
                      senario3_target["Toiture"].push(reponse.title);
                      economie3 += reponse.economie[0];
                      if (combles_amenages) {
                        price3 += reponse.price_functions.comble_amenages(shab, nb_niv);
                      } else {
                        price3 += reponse.price_functions.combles_perdus(shab, nb_niv);
                      }
                      break;
                    case 'Isolation des murs':
                      senario3_target['Murs'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      switch (maison_mitoyenne) {
                        case "Maison non mitoyenne":
                          price3 += reponse.price_functions.maison_non_mitoyenne(shab);
                          break;
                        case "Maison mitoyenne d'un côté":
                          price3 += reponse.price_functions.maison_mitoyenne_un_cote(shab);
                          break;
                        case "Maison mitoyenne des deux côtés":
                          price3 += reponse.price_functions.maison_mitoyenne_deux_cotes(shab);
                          break;
                      }
                    case 'Isolation des sols':
                      senario3_target['Planchers bas'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions.calcule(nb_niv, shab);
                      break;
                    case 'Remplacement des fenêtres':
                      senario3_target['Fenêtres'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions.calcule(shab);
                      break;
                    case 'Changement de chauffage pour des radiateurs électriques connectés avec batterie de stockage intégrée':
                      senario3_target['Chauffage'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions[0](shab);
                      break;
                    case 'Changement de chauffage pour une pompe à chaleur ':
                      senario3_target['Chauffage'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions(shab);
                      break;
                    case 'Changement de système d\'eau chaude sanitaire pour un boiler électrique':
                      senario3_target['Système d\'eau chaude sanitaire'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions();
                      break;
                    case 'Changement de système d\'eau chaude sanitaire pour un boiler thermodynamique':
                      senario3_target['Système d\'eau chaude sanitaire'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions();
                      break;
                    case 'Installation de panneaux solaires':
                      senario3_target['Photovoltaique'].push(reponse.title);
                      break;
                    case 'Installation d\'une VMC simple flux':
                      senario3_target['VMC'].push(reponse.title);
                      economie3 += reponse.economie[0];
                      price3 += reponse.price_functions();
                      break;
                    case 'Aucun':
                      break;
                  }
                  if (reponse.geste) {
                    ++g_3;
                  }
                });
                break;
              case 'Quel est votre mode de chauffage principal ?':
                targetScenario["Chauffage"].push(senario.solution);
                senario.number === 1 ? price1 += value.price_functions[0](shab) : value.price_functions[1] ? price2 += value.price_functions[1](shab) : price2 += value.price_functions[0](shab);
                console.log(value.price_functions[0](shab));
                break;
              case "Votre toiture est-elle isolée ?":
                targetScenario["Toiture"].push(senario.solution);
                if (senario.number === 1) {
                  if (combles_amenages) {
                    price1 += value.price_functions.comble_amenages(shab, nb_niv);
                    console.log(value.price_functions.comble_amenages(shab, nb_niv));
                  } else {
                    price1 += value.price_functions.combles_perdus(shab, nb_niv);
                    console.log(value.price_functions.combles_perdus(shab, nb_niv));
                  }
                }
                if (senario.number === 2) {
                  if (combles_amenages) {
                    price2 += value.price_functions.comble_amenages(shab, nb_niv);
                    console.log(value.price_functions.comble_amenages(shab, nb_niv));
                  } else {
                    price2 += value.price_functions.combles_perdus(shab, nb_niv);
                    console.log(value.price_functions.combles_perdus(shab, nb_niv));
                  }
                }
                break;
              case "Vos murs sont-ils isolés par l'extérieur ?":
              case "Vos murs sont-ils isolés par l'intérieur ?":
                targetScenario["Murs"].push(senario.solution);
                if (senario.number === 1 && !iso_murs) {
                  switch (maison_mitoyenne) {
                    case "Maison non mitoyenne":
                      price1 += value.price_functions.maison_non_mitoyenne(shab);
                      console.log(value.price_functions.maison_non_mitoyenne(shab));
                      break;
                    case "Maison mitoyenne d'un côté":
                      price1 += value.price_functions.maison_mitoyenne_un_cote(shab);
                      console.log(value.price_functions.maison_mitoyenne_un_cote(shab));
                      break;
                    case "Maison mitoyenne des deux côtés":
                      price1 += value.price_functions.maison_mitoyenne_deux_cotes(shab);
                      console.log(value.price_functions.maison_mitoyenne_deux_cotes(shab));
                      break;
                  }
                  iso_murs = true;
                }
                if (senario.number === 2 && !iso_murs) {
                  switch (maison_mitoyenne) {
                    case "Maison non mitoyenne":
                      price2 += value.price_functions.maison_non_mitoyenne(shab);
                      console.log(value.price_functions.maison_non_mitoyenne(shab));
                      break;
                    case "Maison mitoyenne d'un côté":
                      price2 += value.price_functions.maison_mitoyenne_un_cote(shab);
                      console.log(value.price_functions.maison_mitoyenne_un_cote(shab));
                      break;
                    case "Maison mitoyenne des deux côtés":
                      price2 += value.price_functions.maison_mitoyenne_deux_cotes(shab);
                      console.log(value.price_functions.maison_mitoyenne_deux_cotes(shab));
                      break;
                  }
                  iso_murs = true;
                }
                console.log(value.price_functions);
                break;
              case "Votre sol ou plafond de cave est-il isolé ?":
                if (senario.number === 1) {
                  price1 += value.price_functions.calcule(nb_niv, shab);
                  console.log(value.price_functions.calcule(nb_niv, shab));
                } else if (senario.number === 2) {
                  console.log(value.price_functions.calcule(nb_niv, shab));
                  price2 += value.price_functions.calcule(nb_niv, shab);
                }
                targetScenario["Planchers bas"].push(senario.solution);
                console.log(value.price_functions);
                break;
              case "Quel type de vitrage avez-vous ?":
                targetScenario["Fenêtres"].push(senario.solution);
                if (senario.number === 1) {
                  price1 += value.price_functions.calcule(shab);
                  console.log(value.price_functions.calcule(shab));
                }
                if (senario.number === 2) {
                  price2 += value.price_functions.calcule(shab);
                  console.log(value.price_functions.calcule(shab));
                }
                console.log(value.price_functions);
                break;
              case "Avez-vous un système de ventilation ?":
                if (senario.number === 1) {
                  price1 += value.price_functions();
                  console.log(value.price_functions());
                } else if (senario.number === 2) {
                  price2 += value.price_functions();
                  console.log(value.price_functions());
                }
                console.log(value.price_functions);
                targetScenario["VMC"].push(senario.solution);
                break;
              case "Avez-vous une installation photovoltaïque ?":
                targetScenario["Photovoltaique"].push(senario.solution);
                break;
              case "Quel est votre système d'eau chaude sanitaire ?":
                if (senario.number === 1 && value.price_functions[0]) {
                  price1 += value.price_functions[0]();
                  console.log(value.price_functions[0]());
                }
                if (senario.number === 2 && value.price_functions[0]) {
                  price2 += value.price_functions[0]();
                  console.log(value.price_functions[0]());
                }
                console.log(value.price_functions);
                targetScenario["Système d'eau chaude sanitaire"].push(senario.solution);
                break;
              case "Avez-vous un thermostat connecté ou programmable ?":
                targetScenario["Maitrise de l’énergie"].push(senario.solution);
                break;
            }

            // Mise à jour de l'économie d'énergie
            if (pv && value.economie_pv) {
              if (senario.number === 1) {
                var _ref, _value$economie_pv;
                targetEconomie += (_ref = (_value$economie_pv = value.economie_pv[senario.number - 1]) !== null && _value$economie_pv !== void 0 ? _value$economie_pv : value.economie[senario.number - 1]) !== null && _ref !== void 0 ? _ref : 0;
              }
              if (senario.number === 2) {
                var _ref2, _value$economie_pv2;
                targetEconomie += (_ref2 = (_value$economie_pv2 = value.economie_pv[senario.number - 1]) !== null && _value$economie_pv2 !== void 0 ? _value$economie_pv2 : value.economie_pv[0]) !== null && _ref2 !== void 0 ? _ref2 : 0;
              }
            } else if (value.economie) {
              if (senario.number === 1) {
                var _value$economie;
                targetEconomie += (_value$economie = value.economie[senario.number - 1]) !== null && _value$economie !== void 0 ? _value$economie : 0;
              }
              if (senario.number === 2) {
                var _ref3, _value$economie2;
                targetEconomie += (_ref3 = (_value$economie2 = value.economie[senario.number - 1]) !== null && _value$economie2 !== void 0 ? _value$economie2 : value.economie[0]) !== null && _ref3 !== void 0 ? _ref3 : 0;
              }
            }
            console.log({
              targetEconomie: targetEconomie
            });
            if (senario.number === 1) {
              economie1 = targetEconomie;
            } else {
              economie2 = targetEconomie;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });

    // Mise à jour des états après la boucle
    setScenario1(tempScenario1);
    setScenario2(tempScenario2);
    setScenario3(senario3_target);
    setEconomieEnergie1(economie1);
    setEconomieEnergie2(economie2);
    setEconomieEnergie3(economie3);
    var consommation1 = consomationA - consomationA * (1 - economie1);
    var consommation2 = consomationA - consomationA * (1 - economie2);
    var consommation3 = consomationA - consomationA * (1 - economie3);
    if (g_1 == 2) {
      consommation1 = consommation1 * 0.8;
    }
    if (g_1 == 3) {
      consommation1 = consommation1 * 0.7;
    }
    if (g_1 >= 4) {
      consommation1 = consommation1 * 0.65;
    }
    /**
     * 
     * 
     */
    if (g_2 == 2) {
      consommation2 = consommation2 * 0.8;
    }
    if (g_2 == 3) {
      consommation2 = consommation2 * 0.7;
    }
    if (g_2 >= 4) {
      consommation2 = consommation2 * 0.65;
    }
    /**
      * 
      * 
      */

    if (g_3 == 2) {
      consommation3 = consommation3 * 0.8;
    }
    if (g_3 == 3) {
      consommation3 = consommation3 * 0.7;
    }
    if (g_3 >= 4) {
      consommation3 = consommation3 * 0.65;
    }
    setEconomieAnnuel1(consommation1);
    setEconomieAnnuel2(consommation2);
    setEconomieAnnuel3(consommation3);
    setInvestissement1(price1);
    setInvestissement2(price2);
    setInvestissement3(price3);
  }, [userDatas, nb_niv, shab]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100vw',
      height: '100%',
      overflowX: 'scroll',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 0,
      flex: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(Scenario, {
    investissement: investissement1,
    economieA: economieAnnuelle1,
    scenario: scenario1,
    scenario_number: 1,
    economieEnergie: economieEnergie1
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 0,
      flex: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(Scenario, {
    investissement: investissement2,
    economieA: economieAnnuelle2,
    scenario: scenario2,
    scenario_number: 2,
    economieEnergie: economieEnergie2
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 0,
      flex: 1
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(Scenario, {
    investissement: investissement3,
    economieA: economieAnnuelle2,
    scenario: scenario3,
    scenario_number: 3,
    economieEnergie: economieEnergie3
  }))));
}
function Scenario(_ref44) {
  var scenario = _ref44.scenario,
    scenario_number = _ref44.scenario_number,
    economieEnergie = _ref44.economieEnergie,
    economieA = _ref44.economieA,
    investissement = _ref44.investissement;
  (0, _react.useEffect)(function () {
    console.log({
      economieA: economieA,
      investissement: investissement
    });
  }, [economieEnergie, economieA, investissement]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '2em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      textAlign: 'center',
      fontSize: '1.6em',
      fontWeight: 'bold',
      color: 'white',
      backgroundColor: '#EF5555',
      padding: '0.5em',
      borderRadius: '2.6em'
    }
  }, "Sc\xE9nario: ".concat(scenario_number)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '90%',
      margin: 'auto',
      marginLeft: '5%',
      padding: '1em',
      backgroundColor: '#F6F7F7',
      borderBottomLeftRadius: '1em',
      borderBottomRightRadius: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridGap: '1em'
    }
  }, Object.keys(scenario).map(function (key, index) {
    return scenario[key].length ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: 'black',
        fontWeight: 'bold',
        fontSize: '1.2em',
        padding: '0em'
      },
      key: index
    }, key, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontSize: '1em',
        color: 'black',
        fontWeight: 'normal'
      }
    }, scenario instanceof Array ? scenario[key].map(function (senario, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
        key: index
      }, senario));
    }) : scenario[key])) : null;
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gridGap: '1em',
      marginTop: '2em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'black',
      fontWeight: 'bold',
      fontSize: '1em',
      padding: '#D9D9D9'
    }
  }, "Economie d'\xE9nergie ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'gray',
      fontSize: '1.2em'
    }
  }, (economieEnergie * 100).toFixed(0), "%")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'black',
      fontWeight: 'bold',
      fontSize: '1em',
      padding: '#D9D9D9'
    }
  }, "Economie annuelle ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'gray',
      fontSize: '1.2em'
    }
  }, economieA.toFixed(2), "\u20AC")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'black',
      fontWeight: 'bold',
      fontSize: '1em',
      padding: '#D9D9D9'
    }
  }, "Investissement ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'gray',
      fontSize: '1.2em'
    }
  }, investissement.toFixed(2), "\u20AC")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'black',
      fontWeight: 'bold',
      fontSize: '1em',
      padding: '#D9D9D9'
    }
  }, "ROI ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'gray',
      fontSize: '1.2em'
    }
  }, "".concat(Math.round(1 / (economieA / investissement)), " ans"))))));
}
function Responses(_ref45) {
  var currentQuestion = _ref45.currentQuestion,
    userDatas = _ref45.userDatas,
    addUserDatas = _ref45.addUserDatas,
    selectedResponses = _ref45.selectedResponses,
    setSelectedResponses = _ref45.setSelectedResponses;
  var handleSelect = function handleSelect(response) {
    if (currentQuestion.multiple) {
      setSelectedResponses(function (prev) {
        var updatedResponses = prev.includes(response) ? prev.filter(function (r) {
          return r !== response;
        }) // Supprime si déjà sélectionné
        : [].concat(_toConsumableArray(prev), [response]); // Ajoute si pas encore sélectionné

        // Mise à jour des données utilisateur
        addUserDatas(_objectSpread(_objectSpread({}, userDatas), {}, _defineProperty({}, currentQuestion.title, updatedResponses)));
        return updatedResponses;
      });
    } else {
      setSelectedResponses([response]);
      addUserDatas(_objectSpread(_objectSpread({}, userDatas), {}, _defineProperty({}, currentQuestion.title, response)));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentQuestion.responses.map(function (response, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      style: {
        width: "90%",
        margin: "auto",
        padding: "1em"
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        transitionDuration: "200ms",
        width: "90%",
        backgroundColor: selectedResponses.includes(response) ? "#EF5555" : "#F6F7F7",
        padding: "1em",
        cursor: "pointer",
        textAlign: "center",
        margin: 'auto',
        fontSize: '1em',
        color: selectedResponses.includes(response) ? "#FFFFFF" : "#67737C",
        borderRadius: "0.3em",
        scale: selectedResponses.includes(response) ? "1.05" : "1"
      },
      onClick: function onClick() {
        return handleSelect(response);
      }
    }, response.title));
  }));
}
function Formulaire(_ref46) {
  var userDatas = _ref46.userDatas,
    setuserDatas = _ref46.setuserDatas,
    project = _ref46.project,
    opacity = _ref46.opacity,
    msg = _ref46.msg,
    setMsg = _ref46.setMsg,
    currentIndex = _ref46.currentIndex,
    setCurrentIndex = _ref46.setCurrentIndex,
    nextQuestion = _ref46.nextQuestion;
  var _ref47 = (0, _react.useState)({}),
    _ref48 = _slicedToArray(_ref47, 2),
    formDatas = _ref48[0],
    setFormDatas = _ref48[1];
  var submit = function submit() {
    if (!formDatas.first_name || !formDatas.last_name || !formDatas.tel || !formDatas.email) {
      setMsg('Veuillez remplir tous les champs');
      return;
    }
    setuserDatas(_objectSpread(_objectSpread({}, userDatas), formDatas));
    nextQuestion();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontFamily: project ? project.default_button_font : 'arial',
      opacity: opacity,
      backgroundColor: "rgba(0,0,0,0)",
      width: '100%',
      height: '100%',
      transitionDuration: '200ms',
      transitionTimingFunction: 'ease-in-out'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n                        .btn-suivant {\n                        margin-right: 4em;\n                        background: linear-gradient(94deg, #2630E9 0%, #222642 107.78%) !important;\n                        padding: 1em;\n                        border-radius: 2.4em;\n                        cursor: pointer;\n                        border: gray solid 1px;\n                    }\n                    "), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: '4em',
      color: '#67737C',
      fontSize: '0.6em'
    }
  }, 'Informations personelles'), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: '1em',
      color: 'black',
      fontSize: '1.2em'
    }
  }, 'Veuillez renseigner vos informations personnelles'), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: '1.2em',
      color: 'black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '14vh',
      top: '10vh',
      overflow: 'scroll',
      maxHeight: '52vh'
    }
  }, /*#__PURE__*/_react.default.createElement("label", null, "Pr\xE9nom"), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      border: 'solid 2px gray',
      borderRadius: '5px',
      fontSize: '1.2em'
    },
    onChange: function onChange(e) {
      setFormDatas(_objectSpread(_objectSpread({}, formDatas), {}, {
        first_name: e.target.value
      }));
    },
    value: formDatas.first_name,
    type: "text",
    placeholder: "Pr\xE9nom"
  }), /*#__PURE__*/_react.default.createElement("label", null, "Nom"), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      border: 'solid 2px gray',
      borderRadius: '5px',
      fontSize: '1.2em'
    },
    onChange: function onChange(e) {
      setFormDatas(_objectSpread(_objectSpread({}, formDatas), {}, {
        last_name: e.target.value
      }));
    },
    value: formDatas.last_name,
    type: "text",
    placeholder: "Nom"
  }), /*#__PURE__*/_react.default.createElement("label", null, "Num\xE9ro de t\xE9l\xE9phone"), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      border: 'solid 2px gray',
      borderRadius: '5px',
      fontSize: '1.2em'
    },
    onChange: function onChange(e) {
      setFormDatas(_objectSpread(_objectSpread({}, formDatas), {}, {
        tel: e.target.value
      }));
    },
    value: formDatas.tel,
    type: "tel",
    placeholder: "Num\xE9ro de t\xE9l\xE9phone"
  }), /*#__PURE__*/_react.default.createElement("label", null, "Adresse email"), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      border: 'solid 2px gray',
      borderRadius: '5px',
      fontSize: '1.2em'
    },
    onChange: function onChange(e) {
      setFormDatas(_objectSpread(_objectSpread({}, formDatas), {}, {
        email: e.target.value
      }));
    },
    value: formDatas.email,
    type: "email",
    placeholder: "Adresse email"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '2em',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end',
      alignItems: 'end',
      marginTop: '2em'
    }
  }, currentIndex > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-suivant",
    style: {
      color: 'white',
      marginLeft: '4em',
      padding: '1em',
      borderRadius: '2.4em',
      cursor: 'pointer',
      border: 'gray solid 1px'
    },
    onClick: function onClick() {
      setOpcacity(0);
      setTimeout(function () {
        setCurrentIndex(currentIndex - 1);
        setCurrentQuestion(questions[currentIndex - 1]);
        setOpcacity(1);
      }, 200);
    }
  }, "Pr\xE9c\xE9dent"), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'red',
      fontSize: '0.8em',
      marginRight: '6em',
      width: '100%',
      textAlign: 'center'
    }
  }, msg), /*#__PURE__*/_react.default.createElement("div", {
    className: "btn-suivant",
    style: {
      color: 'white',
      marginRight: '4em',
      padding: '1em',
      borderRadius: '2.4em',
      cursor: 'pointer',
      border: 'gray solid 1px'
    },
    onClick: submit
  }, "Suivant"))));
}
function OpenField(_ref49) {
  var currentQuestion = _ref49.currentQuestion,
    userDatas = _ref49.userDatas,
    addUserDatas = _ref49.addUserDatas;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    style: {
      width: '80%',
      padding: '1em',
      borderRadius: '0.3em',
      border: '2px solid #CCCCCC',
      color: 'black',
      fontSize: '1em',
      margin: 'auto'
    },
    onChange: function onChange(e) {
      return addUserDatas(_objectSpread(_objectSpread({}, userDatas), {}, _defineProperty({}, currentQuestion.title, e.target.value)));
    }
  }));
}
function getUniqueCategories(questions) {
  var categories = _toConsumableArray(new Set(questions.map(function (question) {
    return question.category;
  })));
  return categories;
}
function getCategoryIndex(categories, targetCategory) {
  return categories.indexOf(targetCategory);
}